import { colorSchemeVars } from '@oracle/oraclejet-internal-theme-contract/themeContract.css';
import { typographyVars } from '@oracle/oraclejet-internal-theme-contract/themeContract.css';
import { xUnits } from '#UNSAFE_Theme';
import { extendThemeContractVars } from '#UNSAFE_Theme';

// color scheme default vars
export const monthViewColorSchemeDefault = {
  dayOfTheWeek: {
    color: colorSchemeVars.textIcon.secondary
  }
};
// color scheme light extensions
export const monthViewColorSchemeLight = extendThemeContractVars(monthViewColorSchemeDefault, {}); // No overrides
// color scheme dark extensions
export const monthViewColorSchemeDark = extendThemeContractVars(monthViewColorSchemeDefault, {}); // No overrides

// scale default vars
export const monthViewScaleSchemeDefault = {
  rowGap: xUnits(3),
  columnGap: xUnits(0),
  dayOfTheWeek: {
    lineHeight: `calc(2 * ${typographyVars.body.xs.fontSize})`,
    fontSize: typographyVars.body.xs.fontSize,
    fontWeight: typographyVars.body.xs.fontWeight.semibold
  }
};
// scale lg extensions
export const monthViewScaleSchemeLg = extendThemeContractVars(monthViewScaleSchemeDefault, {}); // No overrides
// scale md extensions
export const monthViewScaleSchemeMd = extendThemeContractVars(monthViewScaleSchemeDefault, {}); // No overrides
// scale sm extensions
export const monthViewScaleSchemeSm = extendThemeContractVars(monthViewScaleSchemeDefault, {}); // No overrides
